// You can still import toast if needed
import { toast } from "react-toastify";

export function checkError(error, logout) {
  // console.log("Error received:", error);
  // const status = error?.response?.data?.statusCode || error?.statusCode;
  const status = error?.response?.status || error?.response?.data?.statusCode || error;

  // function toast401Error(text) {
  //   toast.dismiss(); 
  //   toast.error(text, { autoClose: 2000 });
  // }

  // console.log("djcjj",status)
  if (status === 401) {
    // toast401Error("Session expired. Please Login again.")
    // setTimeout(() => {
      localStorage.removeItem("newChannelAddedprompt");
      localStorage.removeItem("StopAPIRequest");
      if (localStorage.getItem("initial_dashboard_skelton")) {
        localStorage.removeItem("initial_dashboard_skelton");
        }
      logout("true");
    // }, 2100);
    return true;
  }
  return false;
}


// export function getIsoDateString(dateString) {
//   const date:any = new Date(dateString);
//   return isNaN(date) ? null : date?.toISOString()?.split('T')[0];
// }
export function getIsoDateString (dateString) {
  const date:any = new Date(dateString);
  if (isNaN(date)) return null;

  const day = String(date.getUTCDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  return `${day} ${month}, ${year}`;
}
// export function getIsoDateString(dateString: string): string | null {
//   // Attempt to parse the date string

//   console.log("djsdjsdbfhuhufeuhweuhewuhe",dateString)
//   const parsedDate = new Date(dateString);
//   if (isNaN(parsedDate.getTime())) {
//     return null; // Invalid date
//   }

//   // Format as "dd Mmm, yyyy"
//   const day = String(parsedDate.getUTCDate()).padStart(2, '0');
//   const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
//                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   const month = monthNames[parsedDate.getUTCMonth()];
//   const year = parsedDate.getUTCFullYear();

//   return `${day} ${month}, ${year}`;
// }



export const SellercloudCompanyList = [
  'Power Systems Website',
  'Schmécké',
  'Best Buy Canada - Kodak',
  'Sunny and Fun New',
  'Color Coded Clean',
  'UK VC DF',
  'kodak-photo-plus-uk',
  'NocNoc',
  'LifePrint',
  'Raxgo',
  'OJ Commerce',
  'SPO Kodak',
  'The Bay',
  'Growers Connect',
  'SPO Sunny and Fun',
  'Nordstrom',
  'Hoop',
  'Ritz Camera',
  'eBay Canada',
  'TikTok Lyxpro',
  'Plum',
  'Anthropologie Marketplace',
  'Coravin',
  'Kodak',
  'JumblCrafts',
  'Logia Printers',
  'Ivation',
  'Snappy DS - IE',
  'Flowtron Shopify',
  'Todays Shopping Choice',
  'Walmart Canada',
  'C+A Global',
  'XXXLutz DE Marketplace',
  'HP Sprocket',
  'Arf Pets',
  'Tiendamia',
  'Hike Crew',
  'Ivation Wine Coolers',
  'NFM',
  'Deway',
  "Kohl's",
  'Bed Bath Canada',
  'Jumbl',
  'Overstock Dropship',
  'LifePrint Frames',
  'hpworksolutions',
  'SARIS',
  'HP Sprocket CA',
  'Saris Vendor Central',
  'BassPro',
  'Kroger Marketplace',
  'UFA',
  'TikTok HP',
  'kodak-photo-plus-ca',
  'Tik Tok Saris',
  'Logia Weather',
  'UK',
  'Parts iD',
  'Best Buy Canada',
  'HP Sprocket EU',
  'LiveFine',
  'PyramydAir Marketpalce',
  'FBA Shipments',
  'Saks',
  'Kodak Projector',
  'Michaels',
  'Mercado Libre',
  'Reebelo',
  'WAVE',
  'Royal Caribbean Marketplace',
  'LyxPro',
  'DE VC DF',
  'Woot',
  'Belk',
  'Debenhams',
  'Oriental Trading',
  'France - Cdiscount',
  'Chewy',
  'HP Sprocket UK',
  'Flowtron Website',
  'Bed Bath and Beyond',
  'Tik Tok Kodak',
  'NBC Universal',
  'Catch AU',
  'SPO HP',
  'Tik Tok Skymall',
  'Macys Marketplace',
  'GE Trucheck',
  'The Knot',
  'kodak-photo-plus-eu',
  'Throne',
];


export function stringToBoolean(str) {
  return ['true', '1', 'yes'].includes(str?.toLowerCase());
}


// First letter capital start
export function capitalizeFirstLetter(input) {
  const string = String(input); // converts true/false to "true"/"false"
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// First letter capital end